import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  IconButton,
  Menu,
  Avatar,
  MenuItem,
} from "@mui/material";
import SideNavbar from "../../../components/sideNavbar";
// import axios from "axios";
import Timmer from "./Timmer";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import WelcomeSection from "./WelcomeSection";
import CustomerQueries from "./CustomerQueries";
import Header from "../../../components/header";
import axiosInstance from "../../../services/axiosInstance";
import { useNavigate } from "react-router-dom";
import BarGraph from "./BarGraph";
import { dummyDashboardData } from "../../../utils/dummyData";
import { Alert } from "@mui/material";



function DashBoard() {
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const [data, setData] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [tickets, setTicket] = useState([]);
  const [ticketType, setTicketType] = useState([]);
  const [stats, setStats] = useState({});
  const [calls, setCalls] = useState({});
  const [isDemoMode, setIsDemoMode] = useState(false);


  useEffect(() => {
    getData();
    getSingleUser();
  }, []);

  const getSingleUser = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.getSingleUser}/${userId}`
      );

      setUserDetails(res?.data?.user);
      if (!localStorage.getItem("memberId")) {
        localStorage.setItem("username", res.data.user.name);
      }
      localStorage.setItem("selectedPhone", res.data.user.customerCareNo);
      localStorage.setItem("companyName", res.data.user.companyName);
      localStorage.setItem("startDate", res.data.user.createdAt);
      localStorage.setItem("loginMethod", res.data.user.loginMethod);
      if (res?.data?.user?.dropoff !== "demo") {
        navigate("/form");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getData = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.getUserCompanyDetails}/${userId}`
      );

      setData(res?.data?.user);
      setTicket(res?.data?.tickets);
      setTicketType(res?.data?.ticketType);

      const realStats = res?.data?.stats || {};
      const realCalls = res?.data?.callDetails || {};

      // Determine if we should show demo data
      if ((!realStats.all || realStats.all === 0) && (!realCalls.totalCalls || realCalls.totalCalls === 0)) {
        setIsDemoMode(true);
        setStats(dummyDashboardData.stats);
        setCalls(dummyDashboardData.callDetails);
        setTicket(dummyDashboardData.tickets);
        setTicketType(dummyDashboardData.ticketType);
      } else {
        setIsDemoMode(false);
        setStats(realStats);
        setCalls(realCalls);
      }
    } catch (error) {

      console.error("Error fetching data:", error);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          ml: { xs: "0px", md: "280px" },
        }}
      >
        <SideNavbar data={data} />
        <Box
          sx={{
            display: {
              xs: "none",
              md: "initial",
            },
          }}
        >
          <Header title={"Dashboard"} />
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pl: 3,
            pr: 3,
          }}
        >
          {isDemoMode && (
            <Alert
              severity="info"
              sx={{
                mt: 3,
                borderRadius: 2,
                fontWeight: 600,
                backgroundColor: "#e0f2fe",
                color: "#0369a1",
                border: "1px solid #7dd3fc"
              }}
            >
              Demo Mode: You are viewing sample data.
            </Alert>
          )}
          <Grid

            container
            alignItems="center"
            justifyContent="space-between"
          // sx={{ mb: 2 }}
          >
            {/* Dashboard Title */}
            <Grid item xs={12} md="auto" sx={{ display: "flex" }}>
              {/* <Typography
                variant="h4"
                sx={{
                  fontWeight: 500,
                  mb: 1,
                }}
              >
                Dashboard
              </Typography> */}
            </Grid>
          </Grid>

          <WelcomeSection
            data={data}
            stats={stats}
            tickets={tickets}
            calls={calls}
            userDetails={userDetails}
          />
          <CustomerQueries
            data={data}
            tickets={tickets}
            ticketType={ticketType}
            stats={stats}
            isDemoMode={isDemoMode}
          />

          <Box
            sx={{
              pb: 4,
            }}
          >
            <BarGraph isDemoMode={isDemoMode} />


          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default DashBoard;
